import { useState } from 'react';
import ChargerModule from '../../components/chargerModule';
import CatalogueModule from './CatalogueModule';
import useFiltersState from '../../state/useFiltersState';
import { ISharedModules } from '../../types/orders';
import useCatalogueState from '../../state/useCatalogueState';

const Catalogue = () => {
  const { setCatalogueSearchbarText, catalogueSearchbarText, sharedModule, setSharedModule } = useFiltersState();
  const { setActiveProducts, activeProducts, setListOfCheckedProducts } = useCatalogueState();
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  const [sharedModules, setSharedModules] = useState<ISharedModules[]>([
    { title: 'Activo', key: 1, active: true },
    { title: 'inactivo', key: 2, active: false }
  ]);

  const sharedModulesAction = (key: number) => {
    const newList: ISharedModules[] = [];
    for (const module of sharedModules) {
      const newModule = {
        key: module.key,
        title: module.title,
        active: module.key === key ? true : false
      };
      if (newModule.active) {
        setSharedModule(newModule);
      }
      newList.push(newModule);
    }
    if (activeProducts) {
      setActiveProducts(false);
      setListOfCheckedProducts([])
    } else {
      setActiveProducts(true);
    }
    setSharedModules([...newList]);
  };

  const headerInfo = { title: 'Catalogo', subtitle: '' };
  const infoSideBar = { position: 'catalog' };

  const changeStateFirsLoad = (state: boolean) => {
    setFirstLoad(state);
  };

  return (
    <ChargerModule
      headerInfo={headerInfo}
      infoSideBar={infoSideBar}
      viewSearchBar
      searchText={catalogueSearchbarText}
      loadingSearchBar={firstLoad}
      sharedModule={sharedModule}
      sharedModules={sharedModules}
      sharedModulesAction={sharedModulesAction}
      setSearchText={setCatalogueSearchbarText}
    >
      <CatalogueModule
        searchText={catalogueSearchbarText?.trim()}
        setSearchText={setCatalogueSearchbarText}
        changeStateFirsLoad={changeStateFirsLoad}
      />
    </ChargerModule>
  );
};
export default Catalogue;
